import type { AddressUsage } from '~/api/DeliveryAddress';
import { company } from '~/company/Company';

/**
 * Fulfilment type to assume for a saved address that carries no `usage` tag.
 *
 * Only tenants that distinguish fulfilment types persist the tag — both save
 * helpers drop it for everyone else — so on a tenant where every address IS a
 * pickup point, an untagged address is a pickup point rather than a street
 * address. That covers MCosmetic's addresses saved before courier delivery was
 * enabled and DubaiExpress's ПВЗ. Reading those as `delivery` binds a PUDO
 * order to a courier zone and renders a locker as a home address.
 */
const untaggedAddressUsage = (): AddressUsage =>
  company.isPudoOnly || company.isExternalPickupPoints ? 'pickup' : 'delivery';

/**
 * Effective fulfilment type of a saved address: its own tag when it has one,
 * the tenant's default otherwise. Every reader of `usage` resolves it through
 * here instead of defaulting to `delivery` on its own.
 */
export const resolveAddressUsage = (usage?: AddressUsage): AddressUsage =>
  usage ?? untaggedAddressUsage();
